import type { DocumentFragment } from '~app/graph/generated/graphql'

export const renderScanId = (document: DocumentFragment) =>
  document.scanMetadata?.scanId
